import { Text, Box, Flex } from '@chakra-ui/react';
import { getIn } from 'formik';
import * as _ from 'lodash';
import React, { useState } from 'react';

import { WipConfig } from '../../types';
import { StickyHeaderSection } from 'packages/common-frontend/components/StickyHeaderSection';
import { AddButton } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddButton';
import { AddPropertyModal } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddPropertyModal';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { PartyEntities } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/PartyEntities';
import { PropertyTable } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/PropertyTable';

type FacilityMechanicsProps = {
  facilityMechanics: CreditAgreement.DomainEntity.FacilityMechanicsWithEntities;
  wipConfig?: WipConfig;
};
export const FacilityMechanics = ({
  facilityMechanics,
  wipConfig,
}: FacilityMechanicsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { parties } = facilityMechanics;
  const basePropertyKey = 'facilityMechanics';
  const sanitizedProperties = _.omit(facilityMechanics, 'parties');
  const propertyPairs = _.toPairs(sanitizedProperties);

  return (
    <>
      <StickyHeaderSection labelText="Facility Mechanics">
        <Box>
          <Flex alignItems="center" mb="2">
            <Text fontWeight="bold" fontSize="24px">
              Properties
            </Text>
            {wipConfig?.isMutateAllowed(basePropertyKey) && (
              <>
                <AddButton setIsOpen={setIsOpen} />
                <AddPropertyModal
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  wipConfig={wipConfig}
                  basePropertyKey={basePropertyKey}
                  propertyMap={getIn(
                    wipConfig.creditAgreementFullArtifactPropertyMap,
                    basePropertyKey,
                  )}
                />
              </>
            )}
          </Flex>
          <Box mb="50px">
            <PropertyTable
              propertyPairs={propertyPairs}
              basePropertyKey={basePropertyKey}
              wipConfig={wipConfig}
            />
          </Box>
          <PartyEntities
            parties={parties}
            basePropertyKey={basePropertyKey}
            wipConfig={wipConfig}
          />
        </Box>
      </StickyHeaderSection>
    </>
  );
};
